
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Breadcrumb } from "@components/breadcrumb";
import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import type { GetStaticProps, NextPage } from "next/types";
import { ALU } from "../../../consts/aalu";
import type { IProduct } from "../../../types/products";
import { getAllAluByParent } from "../../../utils/get-products";
interface IProductPage {
    products: IProduct[];
}
const AluAccesoriesPage: NextPage<IProductPage> = ({ products }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/alu/accessories", hrefLang: "x-default" },
        { href: "https://knswindows.com/alu/accessories", hrefLang: "en" },
        { href: "https://knsokna.pl/alu/accessories", hrefLang: "pl" },
        { href: "https://knsfenster.de/alu/accessories", hrefLang: "de" },
        { href: "https://kns-okna.eu/alu/accessories", hrefLang: "cs" },
        { href: "https://knsfinestre.it/alu/accessories", hrefLang: "it" },
        { href: "https://knsfenetres.fr/alu/accessories", hrefLang: "fr" },
        { href: "https://knsokna.eu/alu/accessories", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
        <Breadcrumb />
        <Products products={products}/>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products } = await getAllAluByParent(ALU.ACCESORIES[LOCALE as keyof typeof ALU.ACCESORIES], LOCALE);
    return {
        props: {
            products,
        },
    };
};
export default AluAccesoriesPage;

    async function __Next_Translate__getStaticProps__1a19cd2bfb2__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/alu/accessories/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bfb2__ as getStaticProps }
  